import { render, staticRenderFns } from "./RateWorkouts.vue?vue&type=template&id=02582996&scoped=true"
import script from "./RateWorkouts.vue?vue&type=script&lang=js"
export * from "./RateWorkouts.vue?vue&type=script&lang=js"
import style0 from "./RateWorkouts.vue?vue&type=style&index=0&id=02582996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02582996",
  null
  
)

export default component.exports